export default __webpack_public_path__ + "static/media/edit.ec8fc043.svg";